import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var sparkNextColors = {
  black: 'rgba(20, 20, 20, 1)',
  white: 'rgba(255, 255, 255, 1)',
  grey_50: 'rgba(243, 243, 243, 1)',
  grey_100: 'rgba(232, 232, 232, 1)',
  grey_200: 'rgba(208, 208, 208, 1)',
  grey_300: 'rgba(185, 185, 185, 1)',
  grey_400: 'rgba(161, 161, 161, 1)',
  grey_500: 'rgba(137, 137, 137, 1)',
  grey_600: 'rgba(114, 114, 114, 1)',
  grey_700: 'rgba(91, 91, 91, 1)',
  grey_800: 'rgba(67, 67, 67, 1)',
  grey_900: 'rgba(44, 44, 44, 1)',
  black_tint_50: 'rgba(20, 20, 20, 0.05000000074505806)',
  black_tint_100: 'rgba(20, 20, 20, 0.10000000149011612)',
  black_tint_200: 'rgba(20, 20, 20, 0.20000000298023224)',
  black_tint_300: 'rgba(20, 20, 20, 0.30000001192092896)',
  black_tint_400: 'rgba(20, 20, 20, 0.4000000059604645)',
  black_tint_500: 'rgba(20, 20, 20, 0.5)',
  black_tint_600: 'rgba(20, 20, 20, 0.6000000238418579)',
  black_tint_700: 'rgba(20, 20, 20, 0.699999988079071)',
  black_tint_800: 'rgba(20, 20, 20, 0.800000011920929)',
  black_tint_900: 'rgba(20, 20, 20, 0.8999999761581421)',
  white_tint_50: 'rgba(255, 255, 255, 0.05000000074505806)',
  white_tint_100: 'rgba(255, 255, 255, 0.10000000149011612)',
  white_tint_200: 'rgba(255, 255, 255, 0.20000000298023224)',
  white_tint_300: 'rgba(255, 255, 255, 0.30000001192092896)',
  white_tint_400: 'rgba(255, 255, 255, 0.4000000059604645)',
  white_tint_500: 'rgba(255, 255, 255, 0.5)',
  white_tint_600: 'rgba(255, 255, 255, 0.6000000238418579)',
  white_tint_700: 'rgba(255, 255, 255, 0.699999988079071)',
  white_tint_800: 'rgba(255, 255, 255, 0.800000011920929)',
  white_tint_900: 'rgba(255, 255, 255, 0.8999999761581421)',
  blue_50: 'rgba(229, 243, 255, 1)',
  blue_100: 'rgba(189, 220, 255, 1)',
  blue_200: 'rgba(121, 195, 255, 1)',
  blue_300: 'rgba(56, 171, 252, 1)',
  blue_400: 'rgba(0, 153, 249, 1)',
  blue_500: 'rgba(0, 136, 244, 1)',
  blue_600: 'rgba(0, 122, 230, 1)',
  blue_700: 'rgba(0, 104, 211, 1)',
  blue_800: 'rgba(0, 87, 192, 1)',
  blue_900: 'rgba(0, 57, 160, 1)',
  green_50: 'rgba(229, 253, 237, 1)',
  green_100: 'rgba(191, 248, 211, 1)',
  green_200: 'rgba(145, 244, 182, 1)',
  green_300: 'rgba(80, 240, 148, 1)',
  green_400: 'rgba(0, 234, 122, 1)',
  green_500: 'rgba(0, 226, 101, 1)',
  green_600: 'rgba(0, 209, 89, 1)',
  green_700: 'rgba(0, 189, 76, 1)',
  green_800: 'rgba(0, 171, 64, 1)',
  green_900: 'rgba(0, 137, 43, 1)',
  red_50: 'rgba(255, 232, 236, 1)',
  red_100: 'rgba(255, 203, 212, 1)',
  red_200: 'rgba(255, 134, 156, 1)',
  red_300: 'rgba(250, 84, 118, 1)',
  red_400: 'rgba(242, 45, 90, 1)',
  red_500: 'rgba(234, 0, 64, 1)',
  red_600: 'rgba(219, 0, 63, 1)',
  red_700: 'rgba(198, 0, 61, 1)',
  red_800: 'rgba(179, 0, 60, 1)',
  red_900: 'rgba(144, 0, 57, 1)',
  yellow_50: 'rgba(255, 253, 230, 1)',
  yellow_100: 'rgba(255, 250, 193, 1)',
  yellow_200: 'rgba(255, 245, 154, 1)',
  yellow_300: 'rgba(255, 242, 114, 1)',
  yellow_400: 'rgba(253, 236, 80, 1)',
  yellow_500: 'rgba(250, 231, 46, 1)',
  yellow_600: 'rgba(253, 216, 45, 1)',
  yellow_700: 'rgba(252, 192, 37, 1)',
  yellow_800: 'rgba(250, 167, 29, 1)',
  yellow_900: 'rgba(246, 126, 15, 1)'
};
var sparkNextSemanticColors = {
  blue_primary: sparkNextColors.blue_200,
  blue_secondary: sparkNextColors.blue_100,
  green_primary: sparkNextColors.green_300,
  green_secondary: sparkNextColors.green_100,
  red_primary: sparkNextColors.red_200,
  red_secondary: sparkNextColors.red_100,
  yellow_primary: sparkNextColors.yellow_300,
  yellow_secondary: sparkNextColors.yellow_100,
  alert_success_dark: sparkNextColors.green_700,
  alert_success_light: sparkNextColors.green_50,
  alert_success_text: sparkNextColors.green_900,
  alert_warning_dark: sparkNextColors.yellow_700,
  alert_warning_light: sparkNextColors.yellow_100,
  alert_error_dark: sparkNextColors.red_400,
  alert_error_light: sparkNextColors.red_50,
  alert_error_text: sparkNextColors.red_500,
  alert_focus: sparkNextColors.blue_500,
  info_bg: sparkNextColors.blue_100,
  info_border: sparkNextColors.blue_700,
  error_bg: sparkNextColors.red_50,
  error_border: sparkNextColors.red_500,
  warning_bg: sparkNextColors.yellow_100,
  warning_border: sparkNextColors.yellow_700,
  success_bg: sparkNextColors.green_50,
  success_border: sparkNextColors.green_800
};
export var sparkColors = _objectSpread(_objectSpread({}, sparkNextSemanticColors), {}, {
  'grey-0': sparkNextColors.white,
  'grey-05': sparkNextColors.grey_50,
  'grey-10': sparkNextColors.grey_100,
  'grey-20': sparkNextColors.grey_200,
  'grey-30': sparkNextColors.grey_300,
  'grey-40': sparkNextColors.grey_400,
  'grey-50': sparkNextColors.grey_500,
  'grey-60': sparkNextColors.grey_600,
  'grey-70': sparkNextColors.grey_700,
  'grey-80': sparkNextColors.grey_800,
  'grey-90': sparkNextColors.grey_900,
  'grey-100': sparkNextColors.black,
  cyan: sparkNextSemanticColors.blue_primary,
  'cyan-10': sparkNextSemanticColors.blue_secondary,
  'cyan-25': sparkNextSemanticColors.blue_secondary,
  blue: sparkNextSemanticColors.blue_primary,
  lightBlue: sparkNextSemanticColors.blue_secondary,
  'lightBlue-20': sparkNextSemanticColors.blue_secondary,
  deepBlue: sparkNextColors.black,
  lightOrange: sparkNextSemanticColors.yellow_primary,
  'lightOrange-25': sparkNextSemanticColors.yellow_secondary,
  orange: '#FFB23F',
  'orange-20': sparkNextSemanticColors.yellow_secondary,
  'orange-25': sparkNextSemanticColors.yellow_secondary,
  'orange-50': sparkNextSemanticColors.yellow_secondary,
  purple: sparkNextSemanticColors.blue_primary,
  'purple-20': sparkNextSemanticColors.blue_primary,
  red: sparkNextSemanticColors.red_primary,
  'red-20': sparkNextSemanticColors.red_secondary,
  'red-25': sparkNextSemanticColors.red_secondary,
  green: sparkNextSemanticColors.green_primary,
  greenPrimary25: sparkNextSemanticColors.green_secondary,
  greenPrimary50: sparkNextSemanticColors.green_secondary,
  greenPrimary100: sparkNextSemanticColors.green_primary,
  error: sparkNextSemanticColors.red_primary,
  success: sparkNextSemanticColors.green_primary,
  warning: sparkNextSemanticColors.yellow_primary,
  focus: sparkNextSemanticColors.blue_primary,
  primary: sparkNextColors.black,
  secondary: sparkNextSemanticColors.blue_secondary
});
var trustyleColors = {
  'accent-1': sparkNextSemanticColors.green_primary,
  'accent-2': sparkNextSemanticColors.green_primary,
  'accent-3': sparkNextSemanticColors.blue_primary,
  'blue-25': sparkNextSemanticColors.blue_secondary,
  'blue-50': sparkNextSemanticColors.blue_secondary,
  'blue-75': sparkNextSemanticColors.blue_primary,
  'dark-1': sparkNextColors.black,
  'dark-2': sparkNextColors.grey_500,
  'dark-3': sparkNextColors.grey_400,
  'light-1': sparkNextColors.white,
  'light-2': sparkNextColors.grey_50,
  'light-3': sparkNextColors.grey_100,
  // Keep these for now
  'primary-yellow-25': '#FFF4D5',
  'primary-yellow-50': '#FFEAAA',
  'primary-yellow-75': '#FFDF80',
  'primary-yellow-100': '#FFD555',
  'secondary-yellow-25': sparkNextSemanticColors.yellow_secondary,
  'secondary-yellow-50': sparkNextSemanticColors.yellow_secondary,
  'secondary-yellow-75': sparkNextSemanticColors.yellow_primary,
  'secondary-yellow-100': sparkNextSemanticColors.yellow_primary,
  tomato: sparkNextSemanticColors.red_primary,
  battleshipGrey: sparkNextColors.grey_600,
  'dark-grey-03': sparkNextColors.white_tint_300,
  'light-grey-content': sparkNextColors.grey_900,
  'light-grey': sparkNextColors.grey_100,
  'uswitch-navy': sparkNextColors.black,
  veryLightGrey: sparkNextColors.grey_50,
  'border-light-grey': sparkNextColors.grey_50,
  'border-medium-grey': sparkNextColors.grey_100,
  'success-green': sparkNextSemanticColors.green_primary,
  'success-mint': sparkNextSemanticColors.green_primary,
  'error-pink': sparkNextSemanticColors.red_secondary,
  'error-red': sparkNextSemanticColors.red_primary,
  'progress-primary': sparkNextSemanticColors.blue_secondary,
  'progress-bg': sparkNextSemanticColors.blue_secondary,
  'secondary-blue': sparkNextSemanticColors.blue_secondary,
  background: 'initial',
  brand: sparkNextSemanticColors.blue_primary,
  'document-bg': sparkNextColors.grey_100,
  'frozen-bg': sparkNextColors.grey_100,
  heading: sparkNextColors.black,
  hero: sparkNextSemanticColors.blue_secondary,
  link: sparkNextColors.grey_600,
  'link-2': sparkNextColors.black,
  'overlay-bg': sparkNextColors.black_tint_500,
  'page-background': 'transparent',
  text: sparkNextColors.black
};
export var colors = _objectSpread(_objectSpread({}, trustyleColors), sparkColors);